import {HELP_NUM_PER_PAGE} from '../constant';
import {HelpItem} from '../type';

export function getHelpPage(helpData: HelpItem[], currentHelpId?: string) {
  if (currentHelpId === undefined) {
    return 0;
  }
  const helpIndex = helpData.findIndex(help => help.id === currentHelpId);
  return Math.floor(helpIndex / HELP_NUM_PER_PAGE) + 1;
}
